/* FB04 — Team selections click-to-filter + horizontal scroll arrows */
(function() {
  if (window.__fb4SelectionsInit) return;
  window.__fb4SelectionsInit = true;

  function getCardTag(card) {
    var cached = card.getAttribute('data-fb4-tag');
    if (cached) return cached;
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';
    var href = link.getAttribute('href') || '';
    var slug = (href.match(/\/products\/([^\/?#]+)/) || [])[1] || '';
    // Lowercase slug for matching
    card.setAttribute('data-fb4-tag', slug.toLowerCase());
    return slug.toLowerCase();
  }

  function applyFilter() {
    var root = document.querySelector('[data-fb4-selections-root]');
    if (!root) return;
    var cards = root.querySelectorAll('.fb4-team-card');
    var active = [];
    cards.forEach(function(c) {
      if (c.classList.contains('is-active')) active.push(c.getAttribute('data-team-tag'));
    });

    var grid = document.querySelectorAll('.product-grid__item');
    var visibleCount = 0;

    if (active.length === 0) {
      root.classList.remove('fb4-selections--has-active');
      grid.forEach(function(c) { c.style.display = ''; });
      removeEmptyState();
      return;
    }

    root.classList.add('fb4-selections--has-active');

    grid.forEach(function(c) {
      var slug = getCardTag(c);
      var match = active.some(function(tag) {
        return slug.indexOf(tag) !== -1;
      });
      c.style.display = match ? '' : 'none';
      if (match) visibleCount++;
    });

    toggleEmptyState(visibleCount === 0);
  }

  function toggleEmptyState(show) {
    var existing = document.querySelector('.fb4-selections__empty');
    if (show && !existing) {
      var grid = document.querySelector('.collection-wrapper');
      if (!grid) return;
      var div = document.createElement('div');
      div.className = 'fb4-selections__empty fb4-season-filter__empty';
      div.textContent = 'No products match the selected team(s). Try another or clear the filter.';
      grid.appendChild(div);
    } else if (!show && existing) {
      existing.remove();
    }
  }

  function removeEmptyState() {
    var existing = document.querySelector('.fb4-selections__empty');
    if (existing) existing.remove();
  }

  function bindArrows(root) {
    var track = root.querySelector('[data-fb4-selections-track]');
    var prev = root.querySelector('[data-fb4-sel-prev]');
    var next = root.querySelector('[data-fb4-sel-next]');
    if (!track || !prev || !next) return;

    function step() {
      var card = track.querySelector('.fb4-team-card');
      if (!card) return track.clientWidth;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap || '16');
      return card.getBoundingClientRect().width + gap;
    }
    function refresh() {
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }
    prev.addEventListener('click', function() { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    next.addEventListener('click', function() { track.scrollBy({ left:  step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', function() { requestAnimationFrame(refresh); }, { passive: true });
    window.addEventListener('resize', refresh);
    setTimeout(refresh, 50);
  }

  function init() {
    var root = document.querySelector('[data-fb4-selections-root]');
    if (!root) return;
    var cards = root.querySelectorAll('.fb4-team-card');

    cards.forEach(function(card) {
      card.addEventListener('click', function() {
        card.classList.toggle('is-active');
        applyFilter();
      });
    });

    bindArrows(root);

    // Re-apply on grid mutations (pagination, infinite scroll)
    var grid = document.querySelector('.collection-wrapper');
    if (grid && window.MutationObserver) {
      var mo = new MutationObserver(function(muts) {
        var hasNew = muts.some(function(m) {
          return Array.prototype.some.call(m.addedNodes, function(n) {
            return n.nodeType === 1 && (n.classList.contains('product-grid__item') || n.querySelector('.product-grid__item'));
          });
        });
        if (hasNew) applyFilter();
      });
      mo.observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
